import { z } from "zod";
import { LVPositionSchema } from "./02-lv-positionen.js";

/**
 * Phase 2 (Pfad B) — Vor-LV aus chained CLI bidi-takeoff → bidi_LV.
 * `provisional: true` markiert die Mengen als „aus unserer Plan-Engine".
 *
 * Wenn die Pipeline-Chain bricht: status='failed' + leere Positionen,
 * Klärpunkt wird in 97-klaerpunkte.json geschrieben.
 */
export const VorLVPositionenSchema = z.object({
  schemaVersion: z.literal(1).default(1),
  pfad: z.literal("B"),
  status: z.enum(["ok", "failed", "partial"]).default("ok"),
  begruendung: z.string().optional(),
  positionen: z
    .array(LVPositionSchema.extend({ provisional: z.literal(true) }))
    .default([]),
  /** Welche Geschwister-Pipeline-Runs haben dieses Vor-LV erzeugt? */
  takeoffRuns: z.array(z.string()).default([]),
  lvRuns: z.array(z.string()).default([]),
});

export type VorLVPositionen = z.infer<typeof VorLVPositionenSchema>;
